import { createDynamicQueryResource } from '@subtile/project-shared';
import type { Accessor } from 'solid-js';
import document, { type RevenuesVars } from '../queries/revenuesQuery';
import type { Revenues } from '../types';

export default (variables: Accessor<RevenuesVars | null>) =>
  createDynamicQueryResource<Revenues, RevenuesVars>(document, variables);
